/*eslint no-extend-native: "off"*/

export { }

declare global {
    interface Date {
        convertLocalToUtcDate(): Date;
        convertUtcToLocalDate(): Date;
        convertDateToTimezone(offset: number): Date;
        putStartOfDay(): Date;
        putEndOfDay(): Date;
    }
}

Date.prototype.convertLocalToUtcDate = function (): Date {
    var d = this;
    return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
}


Date.prototype.convertUtcToLocalDate = function (): Date {
    var d = this;
    return new Date(d.getTime() - (new Date()).getTimezoneOffset() * 60000);
}

Date.prototype.convertDateToTimezone = function (offset: number): Date {
    var d = this;
    var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    return new Date(utc + (3600000 * offset));
}

Date.prototype.putStartOfDay= function (): Date {
    var d = this;
    var nd = new Date(d);
    nd.setHours(0);
    nd.setMinutes(0);
    nd.setSeconds(0);
    return nd;
}
Date.prototype.putEndOfDay = function (): Date {
    var d = this;
    var nd = new Date(d);
    nd.setHours(23);
    nd.setMinutes(59);
    nd.setSeconds(59);
    return nd;
}